import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGraph = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		d: "M29.5 7A2.5 2.5 0 0 0 27 9.5c0 .284.058.551.144.805l-6.094 5.247a2.473 2.473 0 0 0-3.294.16l-4.774-2.39a2.493 2.493 0 1 0-4.742 1.23l-4.867 5.612a2.481 2.481 0 0 0-.873-.166 2.5 2.5 0 1 0 2.314 1.561l4.946-5.685c.236.073.48.124.74.124.727 0 1.377-.316 1.834-.813l4.669 2.341A2.5 2.5 0 0 0 22 17.497c0-.044-.011-.086-.013-.13l6.503-5.587a2.5 2.5 0 1 0 1.01-4.784z"
	})
});
export default SvgGraph;
